export function deleteAllCookies() {
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf("=");
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export function getSortName(param: string): string {
  const name = param && param.split(" ");
  const sortName = name && (name[0].charAt(0) + name[1].charAt(0));
  return sortName;
}

export function getDisplayName(param: string): string {
  return param && param.split(" ")[0];
}

export function stringToDate(str: any) {
  const [dd, mm, yyyy] = str.split('-');
  return new Date(yyyy, mm - 1, dd);
}

export function getFinancialYearsFrom2025(): object[] {
  const years: object[] = [];
  const startYear = 2025;
  const today = new Date();
  // Determine the current financial year start
  const currentFYStart = (today.getMonth() + 1) <= 3 ? today.getFullYear() - 1 : today.getFullYear();
  for (let year = startYear; year <= currentFYStart; year++) {
    years.push({ label: `${year}-${year + 1}`, value: `${year}-${year + 1}` });
  }
  return years;
}

export const defaultClassificationColumns = [
  { columnDisplayName: "Terminal", columnName: "terminalName", selected: true },
  { columnDisplayName: "Object Id", columnName: "objectId", selected: true },
  {
    columnDisplayName: "Object Description",
    columnName: "objectDescription",
    selected: true
  },
  { columnDisplayName: "Task No", columnName: "taskSeq", selected: true },
  {
    columnDisplayName: "Failure Mechanism",
    columnName: "failureMechnism",
    selected: true
  },
  {
    columnDisplayName: "Fault Type Description IFS",
    columnName: "failureMechnismDescription",
    selected: true
  },
  { columnDisplayName: "Cause", columnName: "cause", selected: true },
  {
    columnDisplayName: "Cause Details IFS",
    columnName: "errorCauseDescription",
    selected: true
  },
  { columnDisplayName: "Failure Mode", columnName: "failureMode", selected: true },
  {
    columnDisplayName: "Maintainable Item",
    columnName: "maintainableItem",
    selected: true
  },
  { columnDisplayName: "Maintenance Summary", columnName: "summary", selected: true },
  {
    columnDisplayName: "Preffered Action Description",
    columnName: "performedActionDescription",
    selected: true
  },
  { columnDisplayName: "Accuracy", columnName: "accuracyScore", selected: true },
  { columnDisplayName: "Status", columnName: "status", selected: true },
  {
    columnDisplayName: "Description",
    columnName: "workOrderDescription",
  },
  {
    columnDisplayName: "Translated description in English",
    columnName: "translatedWorkOrderDescription",
  },
  { columnDisplayName: "Work Type", columnName: "workTypeId" },
  {
    columnDisplayName: "Reported Object Site",
    columnName: "terminalCode",
  },
  { columnDisplayName: "Down Time in Hours", columnName: "downTime" },
  { columnDisplayName: "Down Time Type", columnName: "downTimeType" },
  {
    columnDisplayName: "Down Type Description",
    columnName: "downTimeTypeDescription",
  },
  {
    columnDisplayName: "Long Description",
    columnName: "errorCauseLong",
  },
  {
    columnDisplayName: "Translated Long Description in English",
    columnName: "translatedErrorCauseLong",
  },
  {
    columnDisplayName: "Performed Work",
    columnName: "performedActionDescription",
  },
  {
    columnDisplayName: "Translated Performed Work in English",
    columnName: "translatedPerformedWork",
  },
  { columnDisplayName: "Action Taken", columnName: "actionTaken" },

  { columnDisplayName: "Translated Action Taken in English", columnName: "translatedActionTaken" },

];

